import { render, staticRenderFns } from "./MenuRender.vue?vue&type=template&id=0b9ebc59&scoped=true&"
import script from "./MenuRender.vue?vue&type=script&lang=ts&"
export * from "./MenuRender.vue?vue&type=script&lang=ts&"
import style0 from "./MenuRender.vue?vue&type=style&index=0&id=0b9ebc59&scoped=true&lang=css&"
import style1 from "./MenuRender.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9ebc59",
  null
  
)

export default component.exports